import { render, staticRenderFns } from "./NouveauBesoin.vue?vue&type=template&id=685b7dfd"
import script from "./NouveauBesoin.vue?vue&type=script&lang=js"
export * from "./NouveauBesoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports